import { SizableText, VisibilityBadge, XStack, XStackProps } from '@my/ui'
import millify from 'millify'
import React from 'react'

export interface GroupCardInfoExtraProps {
  visibility?: string
  totalMembers: number
  infoWrapperProps?: XStackProps
}

export const GroupCardInfoExtra = ({
  visibility,
  totalMembers,
  infoWrapperProps,
}: GroupCardInfoExtraProps) => {
  return (
    <XStack gap="$2" flexWrap="wrap" ai="flex-start" jc="flex-start" {...infoWrapperProps}>
      {visibility && <VisibilityBadge visibility={visibility} />}
      <SizableText size="$2">
        {millify(totalMembers)} {totalMembers === 1 ? 'Member' : 'Members'}
      </SizableText>
    </XStack>
  )
}
